import React from "react"
import { MY_REPORTS_OPTION, SHARED_WITH_ME_OPTION } from "utils/reportHelpers"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import ReportIndexSidebarOwnershipSectionOwnershipCheckbox from "./ReportIndexSidebarOwnershipSectionOwnershipCheckbox"

const OWNERSHIP_OPTION_LABELS = {
  [MY_REPORTS_OPTION]: "My Reports",
  [SHARED_WITH_ME_OPTION]: "Shared with Me",
}

const ReportIndexSidebarOwnershipSection = () => (
  <SidebarCollapsibleContent title="Ownership">
    {
      Object.entries(OWNERSHIP_OPTION_LABELS).map(([option, label]) => (
        <ReportIndexSidebarOwnershipSectionOwnershipCheckbox
          key={option}
          option={option}
          label={label}
        />
      ))
    }
  </SidebarCollapsibleContent>
)

export default ReportIndexSidebarOwnershipSection
